import React from "react"
import DevicesCard from "./DevicesCard"

const Devices = () => {
  return <DevicesCard />
}

export default Devices
